import { useState } from "react";

import FormData from "../../components/form";
import WarningModal from "../../components/warning";
import Header from "../../components/header";
import NextEvent from "../../components/banners/comandatuba";
import ScrollingBackground from "../../components/line";
import EventBanner from "../../components/eventBanner/comandatuba";
import CardRegistration from "../../components/cardRegistration";
import DescriptionEvent from "../../components/descriptionEvent/comandatuba";
import Tables from "../../components/tables/comandatuba";
import Footer from "../../components/footer";
import ButtonTwo from "../../components/buttonTwo";

import RegistrationsIcon from "../../assets/icons/icons_registrations.svg";

import {
  ContainerCards,
  ContainerRegisteredButton,
  ContainerRegistrations,
  ContentRegistrations,
  ContentTitle,
  DescriptionRegistrations,
  IconRegistrations,
} from "./styles";

const Comandatuba = () => {
  const [openModal, setOpenModal] = useState(false);
  const [modalWarning, setModalWarning] = useState(false);

  const handleClose = () => setOpenModal(false);

  const handleModal = () => {
    setModalWarning(false);
    setOpenModal(true);
  };

  return (
    <>
      <FormData openModal={openModal} handleClose={handleClose} />
      <WarningModal open={modalWarning} handleClose={handleModal} />
      <Header />
      <NextEvent />
      <ScrollingBackground />
      <EventBanner />

      <ContainerRegistrations id="registration">
        <ContentRegistrations>
          <ContentTitle>
            <IconRegistrations src={RegistrationsIcon} alt="icon_inscricao" />
            <span>INSCRIÇÕES DO CAIOBA</span>
          </ContentTitle>

          <ContainerCards>
            <CardRegistration amount="1 INSCRIÇÃO" amountRegistration={1} />
            <CardRegistration amount="2 INSCRIÇÕES" amountRegistration={2} />
            <CardRegistration amount="3 INSCRIÇÕES" amountRegistration={3} />
          </ContainerCards>

          <DescriptionRegistrations>
            <span>*</span>O desconto para segunda e terceira inscrições é válido
            <span> somente para irmãos</span>. <br /> <span>**</span>Descontos
            não acumulativos.
          </DescriptionRegistrations>

          <ContainerRegisteredButton>
            <div>
              <ButtonTwo
                icon={true}
                width="100%"
                onClick={() => setModalWarning(true)}
                className="buttonTwo"
              >
                INSCREVA-SE AGORA
              </ButtonTwo>
            </div>
          </ContainerRegisteredButton>

          <DescriptionRegistrations style={{ marginBottom: 0 }}>
            <span>*</span>Para participar, é necessário fazer as{" "}
            <span>reservas de hotel</span>, e inscrição do Caioba.
          </DescriptionRegistrations>

          <DescriptionRegistrations style={{ fontWeight: 300 }}>
            <span>**</span>Para que a inscrição seja validada a reserva da
            hospedagem precisa ser feita diretamente com o Caioba ou com alguma
            das agências parceiras. Consulte agências parceiras com nosso
            atendimento no WhatsApp.
          </DescriptionRegistrations>
        </ContentRegistrations>
      </ContainerRegistrations>

      <DescriptionEvent />
      <Tables />
      <Footer />
    </>
  );
};

export default Comandatuba;
